export class SaleTypeDTO{
    public id!:number;
    public name!:string;
    public checklistItems?:string;
    
    constructor(){

    }
}